import { styled } from "styled-components";

export const MyProfileImage = styled.img`
  display: flex;
  justify-content: center;
  width: 185px;
  height: 185px;
  border-radius: 30px;
`;
